module.exports = __webpack_public_path__ + "static/img/利害關係人溝通01TW.8b4bd75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/利害關係人溝通01TW.jpg
// module id = BoyU
// module chunks = 1